import { APIEndpoints } from "../../constants";
import { APIPost, APIResponse } from "../api/common.service";
import { LoginCredentials, LoginResponseData } from "../../types";

/**
 * Login endpoint with email, password, and role payload.
 */
export function LoginUsingEmail(
  body: LoginCredentials
): Promise<APIResponse<LoginResponseData>> {
  return APIPost<LoginResponseData>(
    APIEndpoints.LoginUsingEmail,
    undefined,
    undefined,
    body as unknown as Record<string, unknown>
  );
}
